import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { loadCheckEvaluationByReader } from "./ActionEvaluationType";
const END_POINT = process.env.REACT_APP_BASE_URL;


export const postEvaluation = (creative_work_id,notes, evaluationData, setLoad,setEvaluationStatus, setEvaluationStatusType) => {
    return function () {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        console.log(creative_work_id);
        const requestData = {
            creative_evaluation: evaluationData,
            creative_work_id: creative_work_id,
            notes: notes,
        };
        console.log(requestData);
        axios.post(`${END_POINT}/api/evaluations/create`, requestData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                notifysuccess(res.data.message)
                loadCheckEvaluationByReader(setEvaluationStatus, setEvaluationStatusType, creative_work_id)();
                setLoad(true)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}





